import { CollectionData } from "./collections";
import { getCollectionImageUrl } from "@/lib/cloudinary";

export const naturalGreyDescriptionParagraphs = [
  "La collection Natural Grey d'octobre 2023 incarne une fusion entre nature brute et sophistication urbaine. Chaque création explore des textures organiques qui rappellent les paysages naturels tout en jouant avec des formes modernes et audacieuses.",
  "Avec des éléments inspirés de la végétation sauvage et des couleurs terreuses, chaque pièce traduit une histoire unique, mêlant force et délicatesse. Les coiffures sont conçues comme des sculptures vivantes, évoquant la puissance de la nature en mouvement.",
  "Cette collection célèbre une élégance intemporelle, où les matières naturelles se rencontrent dans des compositions artistiques audacieuses. Natural Grey redéfinit le luxe à travers une vision profondément enracinée dans l'authenticité et l'avant-garde.",
];

export const naturalGreyCollection: CollectionData = {
  id: "2023-natural-grey",
  title: "Collection Natural Grey",
  descriptionParagraphs: naturalGreyDescriptionParagraphs,
  images: [
    getCollectionImageUrl("2023-natural-grey", "ALEXANDRA-GREY-NATURAL-GREY-01"),
    getCollectionImageUrl("2023-natural-grey", "ALEXANDRA-GREY-NATURAL-GREY-02"),
    getCollectionImageUrl("2023-natural-grey", "ALEXANDRA-GREY-NATURAL-GREY-03"),
    getCollectionImageUrl("2023-natural-grey", "ALEXANDRA-GREY-NATURAL-GREY-04"),
    getCollectionImageUrl("2023-natural-grey", "ALEXANDRA-GREY-NATURAL-GREY-05"),
    getCollectionImageUrl("2023-natural-grey", "ALEXANDRA-GREY-NATURAL-GREY-06"),
    getCollectionImageUrl("2023-natural-grey", "ALEXANDRA-GREY-NATURAL-GREY-07"),
    getCollectionImageUrl("2023-natural-grey", "ALEXANDRA-GREY-NATURAL-GREY-08"),
    getCollectionImageUrl("2023-natural-grey", "ALEXANDRA-GREY-NATURAL-GREY-09"),
    getCollectionImageUrl("2023-natural-grey", "ALEXANDRA-GREY-NATURAL-GREY-10"),
    getCollectionImageUrl("2023-natural-grey", "ALEXANDRA-GREY-NATURAL-GREY-11"),
    getCollectionImageUrl("2023-natural-grey", "ALEXANDRA-GREY-NATURAL-GREY-12"),
  ],
  date: "10/23",
  bannerImage: getCollectionImageUrl("2023-natural-grey", "ALEXANDRA-GREY-NATURAL-GREY-01"),
};
